import React from 'react'
import {Box, Button, Typography} from '@mui/material'
import {IPassengerChartRoute} from '@containers/monitoringPlatform/passengerCharts/types'
import {routeNumber} from '@containers/monitoringPlatform/passengerCharts/helpers/routeNumber'
import {formatRange} from '@containers/monitoringPlatform/passengerCharts/helpers/formatTime'
import PassengerChart from '@containers/monitoringPlatform/passengerCharts/chart/PassengerChart'
import sx from '@containers/monitoringPlatform/passengerCharts/route/sx'

interface IProps {
	route: IPassengerChartRoute
	onBack: () => void
}

const RouteCharts = ({route, onBack}: IProps) => {
	return (
		<Box>
			<Box sx={sx.header}>
				<Button size="small" variant="outlined" sx={sx.back} onClick={onBack}>← Усі маршрути</Button>
				<Typography sx={sx.title}>Маршрут №{routeNumber(route.routeName)}</Typography>
				<Typography sx={sx.description}>{route.routeDescription}</Typography>
			</Box>

			{route.vypusky.map((vypusk) => {
				const vehicles = vypusk.vehicles
				const plates = Array.from(new Set(vehicles.map((v) => v.licencePlate))).join(', ')
				return (
					<Box key={vypusk.scheduleId} sx={sx.block}>
						<Box sx={sx.blockHead}>
							<Typography sx={sx.blockTitle}>Випуск {vypusk.number}</Typography>
							{vehicles.length > 0 && <Typography sx={sx.description}>
								{plates} · {formatRange(vehicles[0].from, vehicles[vehicles.length - 1].to)}
							</Typography>}
						</Box>
						<PassengerChart vypusk={vypusk}/>
					</Box>
				)
			})}
		</Box>
	)
}

export default RouteCharts
